import { render, staticRenderFns } from "./UpdateServer.vue?vue&type=template&id=9cb6efa8&"
import script from "./UpdateServer.vue?vue&type=script&lang=js&"
export * from "./UpdateServer.vue?vue&type=script&lang=js&"
import style0 from "./UpdateServer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports